import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";

import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
import { IconErrorCircle, IconStar } from "../../assets/icons";
import LazyLoad from "react-lazyload";
import Skeleton from "react-loading-skeleton";

import placeHolderimage from "../../assets/images/load-image.jpg";
import useLazyLoad from "./LazyImage";

function CardTileH6({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
  hasReserveDetail_V2,
  tafrihanSuggestion,
  imageLabelJson,
}) {
  const [loaded, setLoaded] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد
  const [imgHeight, setImgHeight] = useState(0);
  const [imageLabels, setImageLabels] = useState([]);
  const imgWidth = isMobile ? "174px" : "194px";
  const imgHeightValue = isMobile ? "138px" : "150px";
  const skeletonStyle = {
    width: imgWidth,
    height: imgHeightValue,
  };

  useEffect(() => {
    console.log("imageLabelJson===", imageLabelJson);
    var imageLabelList = JSON.parse(imageLabelJson || "[]");
    console.log("imageLabelJson=", imageLabelList);
    setImageLabels(imageLabelList);
  }, [imageLabelJson]);

  return isMobile ? (
    <Link to={amusementUrl}>
      <Card
        className={`p-2 rounded-3 text-center box-shadow-sm h-100  ${
          tafrihanSuggestion ? "special-offer" : ""
        }`}
      >
        {tafrihanSuggestion && (
          <div
            className="rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "0px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}

        {/* <LazyLoad> */}
        {/* <img
            src={itemImgSrc + "?width=200"}
            className="w-100 rounded-3"
            alt={amusementName}
            loading="lazy"
          /> */}
        <div
          ref={ref}
          style={{ position: "relative", width: "100%", height: "138px" }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            alt="placeholder"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=200`}
                alt={amusementName}
                className={`rounded-3 mb-1 w-100 ${
                  isImageLoaded ? "visible" : "invisible"
                }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="tag-on-pic">
                {imageLabels.map((label) => (
                  <div
                    key={label.id}
                    className="rounded-start-2 text-white fs-075 px-2 mt-1"
                    style={{ background: label.BackgroundColor }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: label.LabelText,
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* </LazyLoad> */}
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-09">{amusementName}</h3>
        </Card.Body>
        {hasReserveDetail_V2 ? (
          <Card.Footer className="bg-white border-0 pb-1 px-0 position-relative">
            <Row className="gx-0">
              <Col className="my-auto">
                {amusementFinalPrice > amusementPrice && (
                  <>
                    <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    <span className="fs-08 ps-1">تومان</span>
                  </>
                )}
                <div className="fw-bold text-black">
                  <span className=" text-dark pe-1">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  تومان
                </div>
              </Col>
              <Col xs="auto" className="my-auto">
                <AddToBasketRoundedButton onClick={handleClick} />
              </Col>
            </Row>
          </Card.Footer>
        ) : (
          <Card.Footer className="bg-white border-0 pb-1 px-0 fs-07">
            <IconErrorCircle fillColor="#444" />
            در حال حاضر رزرو غیرفعال است
          </Card.Footer>
        )}
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card
        className={`p-2 rounded-3 text-center box-shadow-sm h-100  ${
          tafrihanSuggestion ? "special-offer" : ""
        }`}
      >
        {/* {tafrihanSuggestion && (
          <div
            className=" text-white  rounded-3 fs-07 center-tag px-2 py-1 position-absolute"
            style={{ bottom: "0px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconOffer fillColor="#e54707" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )} */}
        {tafrihanSuggestion && (
          <div
            className="  rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "-6px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}

        <LazyLoad>
          {/* <img
            src={itemImgSrc + "?width=210"}
            className="w-100 rounded-3"
            alt={amusementName}
            loading="lazy"
          /> */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: imgHeightValue,
            }}
          >
            {!loaded && (
              <Skeleton style={skeletonStyle} className="rounded-3" />
            )}
            <img
              src={itemImgSrc + "?width=210"}
              alt={amusementName}
              className="rounded-3 mb-1"
              style={{
                display: loaded ? "block" : "none",
                width: "100%",
                height: "100%",
              }}
              onLoad={() => setLoaded(true)}
            />
            <div className="tag-on-pic">
              {imageLabels.map((label) => (
                <div
                  key={label.id}
                  className="  rounded-start-2 text-white fs-075 px-2 mt-1"
                  style={{ background: label.BackgroundColor }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: label.LabelText,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </LazyLoad>
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal pb-3 border-bottom">
            {amusementName}
          </h3>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
          {hasReserveDetail_V2 ? (
            ""
          ) : (
            <div className="text-secondary">عدم امکان رزرو</div>
          )}
        </Card.Body>
        {hasReserveDetail_V2 ? (
          <Card.Footer
            className={`bg-white border-0 px-0 position-relative pb-1 `}
          >
            <Row className="gx-0">
              <Col className="my-auto">
                {amusementFinalPrice > amusementPrice ? (
                  <>
                    <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    <span className="fs-08 ps-1">تومان</span>
                  </>
                ) : (
                  ""
                )}
                <div className="fw-bold text-black">
                  <span className=" text-dark pe-1">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  تومان
                </div>
              </Col>
              <Col xs="auto" className="my-auto">
                <AddToBasketRoundedButton onClick={handleClick} />
              </Col>
            </Row>
          </Card.Footer>
        ) : (
          <Card.Footer className="bg-white border-0 px-0 pb-1 fs-07">
            <IconErrorCircle fillColor="#444" />
            در حال حاضر رزرو غیرفعال است
          </Card.Footer>
        )}
      </Card>
    </Link>
  );
}
export default CardTileH6;
